import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import { FILTER_CATEGORY_LABELS, HORIZONTAL_CHIP_ORDER } from "../FilterBar/filterIds";
import {
  MOBILE_CHIP_GAP,
  MOBILE_TOUCH_MIN_PX,
  MOBILE_TYPE,
} from "../../../theme/mobileLayout";

/**
 * Horizontally scrollable row of applied filter chips for mobile Search.
 */
export default function AppliedFiltersRow({
  summaries = {},
  onChipClick,
  onClear,
  showClear = false,
}) {
  const activeIds = HORIZONTAL_CHIP_ORDER.filter((id) => summaries[id]?.isActive);
  if (activeIds.length === 0 && !showClear) return null;

  return (
    <Box
      data-testid="applied-filters-row"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: MOBILE_CHIP_GAP,
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        py: 0.5,
        px: 0.25,
      }}
    >
      {activeIds.map((id) => {
        const summary = summaries[id];
        const baseLabel = summary.displayLabel || summary.label || FILTER_CATEGORY_LABELS[id];
        const countSuffix =
          !summary.displayLabel && summary.variant === "multi" && summary.count > 0
            ? ` · ${summary.count}`
            : "";
        return (
          <Chip
            key={id}
            label={`${baseLabel}${countSuffix}`}
            onClick={() => onChipClick?.(id)}
            size="small"
            sx={{
              height: 32,
              minHeight: 32,
              borderRadius: "999px",
              bgcolor: "secondary.main",
              color: "primary.main",
              ...MOBILE_TYPE.chip,
              "& .MuiChip-label": { px: 1.25 },
              "&:active": { opacity: 0.85 },
            }}
          />
        );
      })}
      {showClear ? (
        <Button
          type="button"
          onClick={onClear}
          sx={{
            ...MOBILE_TYPE.chip,
            color: "#D80000",
            minWidth: 0,
            minHeight: MOBILE_TOUCH_MIN_PX,
            px: 1,
            flexShrink: 0,
            textTransform: "none",
          }}
        >
          Clear
        </Button>
      ) : null}
    </Box>
  );
}

AppliedFiltersRow.propTypes = {
  summaries: PropTypes.object,
  onChipClick: PropTypes.func,
  onClear: PropTypes.func,
  showClear: PropTypes.bool,
};
